"use strict";
// Copyright © Veeam Software Group GmbH
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SynchronizingPeriodInteractor = void 0;
const core_1 = require("@veeam/core");
const rxjs_1 = require("rxjs");
const core_2 = require("../../../../core");
require("../../components");
require("../../types");
const constants_1 = require("../constants");
class SynchronizingPeriodInteractor extends core_1.Interactor {
    constructor(loadableModel, periodModel, widgetName) {
        super();
        this.loadableModel = loadableModel;
        this.periodModel = periodModel;
        this.timerId = null;
        this.subscriptions = new rxjs_1.Subscription();
        this.loadableModel = loadableModel;
        this.periodModel = periodModel;
        this.LOCAL_STORAGE_FILTER_KEY = `period|${widgetName}`;
    }
    loadData(periodId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadableModel.load({ periodId });
        });
    }
    didActivate() {
        return __awaiter(this, void 0, void 0, function* () {
            this.subscriptions.add(this.periodModel.fieldChanges('id').subscribe(({ value }) => __awaiter(this, void 0, void 0, function* () {
                yield this.loadData(value);
                core_2.appStorage.setItem(this.LOCAL_STORAGE_FILTER_KEY, value);
            })));
        });
    }
    willActivate() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const initialPeriodValue = core_2.appStorage.getItem(this.LOCAL_STORAGE_FILTER_KEY);
            if (initialPeriodValue) {
                this.periodModel.setValue({ id: initialPeriodValue });
            }
            this.timerId = window.setInterval(() => {
                this.loadableModel.sync({
                    periodId: this.periodModel.getValue().id,
                });
            }, constants_1.REFRESH_DATA_INTERVAL);
            yield this.loadData((_a = this.periodModel) === null || _a === void 0 ? void 0 : _a.getValue().id);
        });
    }
    willDeactivate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.timerId) {
                window.clearInterval(this.timerId);
            }
            this.subscriptions.unsubscribe();
        });
    }
}
exports.SynchronizingPeriodInteractor = SynchronizingPeriodInteractor;
//# sourceMappingURL=SynchronizingPeriodInteractor.js.map